import { AppletHostErrorCode } from '../applet-host-error-code';

/**
 * @property {string} [message] - The message for this error
 * @property {AppletHostErrorCode} code - The code corresponding to this error.
 * @property {boolean} isAppletHostError - True to indicate this error is an AppletHostError
 */
export class AppletHostError extends Error {
    constructor({ message, code }) {
        super(message);

        if(!AppletHostErrorCode.isValid(code)) {
            throw new Error(`Invalid AppletHostErrorCode passed. Provided value: ${code}`);
        }
        this.isAppletHostError = true;
        this.code = code;

        Object.freeze(this);
    }
}